import React from "react"
import Cabecalho from "../Cabecalho"
import { ModulosContratados } from "./components/ModulosContratados"

export function ModulosFornecedor() {
    return (
        <>
            <Cabecalho pagina="Módulos Contratados" />
            <ModulosContratados />
        </>
    )
}
